import { BASE_COLOR_TO_SURFACE_ID } from '../constants/color-schemes';

const SURFACE_ID_TO_BASE_COLOR = Object.fromEntries(
  Object.entries(BASE_COLOR_TO_SURFACE_ID).map(([baseColor, surfaceId]) => [surfaceId, baseColor])
);

export const mapColorKeysToBaseColors = (colors) =>
  Object.fromEntries(
    Object.entries(colors)
      .map(([colorSchemeId, colorValue]) => {
        const baseColor = SURFACE_ID_TO_BASE_COLOR[colorSchemeId];
        if (!baseColor) return null;
        return [baseColor, colorValue];
      })
      .filter(Boolean)
  );

export const mapBaseColorKeysToSurfaceIds = (colors) =>
  Object.fromEntries(
    Object.entries(colors)
      .map(([baseColor, colorValue]) => {
        const colorSchemeId = BASE_COLOR_TO_SURFACE_ID[baseColor];
        if (!colorSchemeId) return null;
        return [colorSchemeId, colorValue];
      })
      .filter(Boolean)
  );
